{
  "announcement": "Anunsyo",
  "schedule": "Iskedyul",
  "program": "Programa",
  "urgent": "Apurahan",
  "pinned": "Naka-pin",
  "cancelled": "Kinansela",
  "regOpen": "Bukas ang rehistro",
  "regOpenSeats": "Bukas ang rehistro · {count} slot na lang",
  "regOpenSeat": "Bukas ang rehistro · 1 slot na lang",
  "regWaitlist": "Puno na · sumali sa waitlist",
  "regFull": "Puno na",
  "regClosed": "Sarado na ang rehistro",
  "regNotOpen": "Magbubukas ang rehistro {date}",
  "regApproval": "Kailangan ng pag-apruba",
  "registered": "Rehistrado ka na",
  "waitlisted": "Nasa waitlist ka",
  "pendingApproval": "Hinihintay ang pag-apruba",
  "register": "Magparehistro",
  "joinWaitlist": "Sumali sa waitlist",
  "viewTicket": "Tingnan ang aking ticket",
  "addToCalendar": "Idagdag sa kalendaryo",
  "getDirections": "Kumuha ng direksyon",
  "share": "Ibahagi",
  "shareText": "Mula sa {office} sa {app}",
  "eligibility": "Sino ang puwedeng sumali",
  "venue": "Saan",
  "when": "Kailan",
  "sessions": "Mga iskedyul",
  "seatsLeft": "{count} slot na lang",
  "seatLeft": "1 slot na lang",
  "noLimit": "Bukas",
  "sessionFull": "Puno na",
  "attachments": "Mga attachment",
  "postedBy": "Ipinost ng {office}",
  "lastEdited": "Huling na-edit {date}",
  "forBarangays": "Para sa mga residente ng {list}",
  "cancelledBecause": "Kinansela ang event na ito: {reason}",
  "notFound": "Hindi available ang post na ito. Maaaring tapos na o naka-archive.",
  "follow": "Sundan",
  "following": "Sinusundan",
  "followOffice": "Sundan ang {name}",
  "unfollowOffice": "Itigil ang pagsunod sa {name}",
  "followHint": "Maabisuhan kapag nag-post ang opisinang ito.",
  "signInToFollow": "Mag-sign in para sundan ang mga opisina at maabisuhan.",
  "pushPromptTitle": "Gusto mo bang maabisuhan?",
  "pushPromptBody": "I-on ang notifications para sa mga bagong post, update sa rehistro at paalala.",
  "pushEnable": "I-on ang notifications",
  "pushLater": "Mamaya na",
  "pushOn": "Naka-on ang notifications.",
  "pushBlocked": "Naka-block ang notifications sa settings ng browser mo.",
  "pushUnsupported": "Hindi makatanggap ng notifications ang browser na ito. Sa iPhone, idagdag muna ang app sa Home Screen.",
  "tomorrow": "Bukas",
  "happeningNow": "Nangyayari ngayon",
  "ended": "Tapos na",
  "urgentNote": "Apurahang abiso mula sa opisinang ito. Pakibasa ngayon.",
  "cancelledNoReason": "Kinansela ang event na ito.",
  "forEveryone": "Lahat ng taga-{town}",
  "inBarangay": "Barangay {name}",
  "venueMapLabel": "Mapa ng {venue}",
  "attachment": "Attachment",
  "image": "Larawan",
  "followingOffice": "Sinusundan ang {name}",
  "registration": "Rehistro",
  "mineConfirmed": "Kumpirmado ang iyong slot. Ipakita ang QR code ng iyong ticket sa venue.",
  "mineWaitlisted": "Puno na ang event. Aabisuhan ka namin agad kapag may nabakanteng slot.",
  "minePending": "Sinusuri ng opisina ang iyong rehistro. Ipapaalam namin sa iyo.",
  "waitlistExplain": "Puno na ngayon. Sumali sa waitlist at awtomatikong mapupunta sa iyo ang susunod na bakanteng slot; aabisuhan ka namin.",
  "fullNoWaitlist": "Puno na ito at walang waitlist.",
  "regClosedExplain": "Sarado na ang rehistro para dito.",
  "regCloses": "Magsasara ang rehistro {date}",
  "registerFor": "Magparehistro: {title}",
  "noRegistration": "Hindi tumatanggap ng rehistro ang post na ito.",
  "backToPost": "Bumalik sa post",
  "alreadyRegistered": "Nakapagparehistro ka na dito. Nasa iyong ticket ang status mo.",
  "eligibilityNote": "Sino ang puwedeng sumali: {text}",
  "chooseSession": "Pumili ng iskedyul",
  "sessionWaitlist": "Puno · waitlist",
  "prefilledNote": "Pinunan namin ang ilang detalye mula sa iyong profile. Suriin muna bago magpatuloy.",
  "companionsHint": "Mga taong kasama mo. Bawat isa ay kumukuha ng isang slot.",
  "chooseOption": "Pumili…",
  "continueReview": "Suriin ang aking rehistro",
  "fixErrors": "Pakisuri ang mga naka-highlight na field.",
  "errRequired": "Kailangan ito",
  "errTick": "Pakilagyan ng tsek ang kahong ito",
  "errMobile": "Maglagay ng mobile number tulad ng 0917 123 4567",
  "errEmail": "Maglagay ng tamang email",
  "errAge": "Maglagay ng edad mula 0 hanggang 130",
  "errConsent": "Pakisang-ayunan ang privacy notice para magpatuloy",
  "reviewTitle": "Suriin ang iyong detalye",
  "reviewLead": "Tiyaking tama ang lahat, saka kumpirmahin.",
  "sessionLabel": "Iskedyul",
  "editAnswers": "Baguhin ang aking sagot",
  "approvalExplain": "Sinusuri ng opisina ang bawat rehistro. Aabisuhan ka kapag naaprubahan na.",
  "confirmRegister": "Kumpirmahin at magparehistro",
  "confirmWaitlist": "Kumpirmahin at sumali sa waitlist",
  "sending": "Ipinapadala…",
  "doneConfirmed": "Rehistrado ka na!",
  "doneConfirmedBody": "Handa na ang iyong ticket. Ipakita ang QR code nito sa venue.",
  "doneWaitlisted": "Nasa waitlist ka",
  "doneWaitlistedBody": "Ika-{position} ka sa waitlist. Kapag may nabakanteng slot, awtomatiko itong mapupunta sa iyo at aabisuhan ka namin.",
  "donePending": "Natanggap ang rehistro",
  "donePendingBody": "Susuriin ito ng opisina at ipapaalam sa iyo.",
  "seeMyRegistrations": "Tingnan lahat ng aking rehistro",
  "answerYes": "Oo",
  "answerNo": "Hindi",
  "fileHint": "Larawan o PDF (hanggang 2 MB). Ang opisina lang ang makakakita nito.",
  "fileChoose": "Pumili ng file",
  "fileUploading": "Ina-upload…",
  "fileUploaded": "Na-upload ang file",
  "fileRemove": "Alisin ang file",
  "field_name": "Buong pangalan",
  "field_mobile": "Mobile number",
  "field_email": "Email",
  "field_barangay": "Barangay",
  "field_address": "Tirahan",
  "field_birthdate": "Petsa ng kapanganakan",
  "field_age": "Edad",
  "field_sex": "Kasarian",
  "field_rsbsa": "RSBSA number",
  "field_senior_pwd_id": "Numero ng Senior citizen / PWD ID",
  "field_school": "Paaralan",
  "field_companions": "Bilang ng kasama",
  "sex_female": "Babae",
  "sex_male": "Lalaki",
  "sex_prefer_not_to_say": "Ayokong sabihin",
  "ticketTitle": "Aking ticket",
  "ticketNotFound": "Hindi namin makita ang ticket na ito.",
  "ticketCode": "Code ng ticket",
  "ticketShowQr": "Ipakita ang QR code na ito sa venue. Puwede mo ring ibigay ang code ng ticket.",
  "ticketWaitlistBody": "Kapag may nabakanteng slot, awtomatiko kang aakyat at aabisuhan ka namin.",
  "ticketPendingBody": "Sinusuri ng opisina ang iyong rehistro. Lalabas ang QR code kapag naaprubahan na.",
  "qrAlt": "QR code ng ticket {code}",
  "checkedIn": "Naka-check in {time}",
  "waitlistPosition": "Ika-{position} ka sa waitlist",
  "declined": "Hindi naaprubahan",
  "declinedBody": "Hindi naaprubahan ng opisina ang rehistrong ito.",
  "officeNote": "Paalala mula sa opisina: {note}",
  "registrationCancelled": "Kinansela",
  "cancelledOn": "Kinansela {date}",
  "groupSize": "Grupo",
  "youPlusCompanion": "Ikaw + 1 kasama",
  "youPlusCompanions": "Ikaw + {count} kasama",
  "registeredOn": "Petsa ng rehistro",
  "viewEvent": "Tingnan ang event",
  "yourAnswers": "Ang iyong mga sagot",
  "cancelRegistration": "Kanselahin ang aking rehistro",
  "cancelUntil": "Puwede kang magkansela hanggang {date}.",
  "cancelClosed": "Lumipas na ang deadline ng pagkansela. Makipag-ugnayan sa opisina kung hindi ka makakadalo.",
  "cancelConfirmTitle": "Kanselahin ang iyong rehistro?",
  "cancelConfirmBody": "Mapupunta ang iyong slot sa susunod na nasa waitlist. Maaaring hindi mo na ito makuha muli.",
  "cancelConfirmWaitlist": "Aalis ka sa waitlist.",
  "cancelYes": "Oo, kanselahin",
  "cancelKeep": "Huwag",
  "cancelDone": "Nakansela ang iyong rehistro."
}
